// Native
import { useEffect, useState } from "react"
import { useNavigate } from "react-router"

// Components
import { Button, ButtonGroup, Modal, ModalCloseButton, ModalFooter, ModalContent, ModalBody, ModalOverlay, Td, useDisclosure, Text } from "@chakra-ui/react"
import { Container, Searchable, Table, Heading, IconButton, Row, Dev, Form, OptionModals } from "components"

// Config
import { Moment } from "config"

// Hooks
import useOptions from "hooks/useOptions"

export default function Options() {

    const [term, setTerm] = useState(null)
    const [page, setPage] = useState(1)

    const [ actualKey, setActualKey ] = useState()
    const [ optionKey, setOptionKey ] = useState()

    const options = useOptions(page, term)

    const updateOption = useDisclosure()
    const addOption = useDisclosure()

    const columns = [
        { title: "Chave:" },
        { title: "Valor:" },
        { title: "Data de Criação:" },
        { title: "Data de Atualização:" },
    ]

    const handleOpenUpdateOptionModal = (optionKey) => {
        setOptionKey(optionKey)
        updateOption.onOpen()
    }

    useEffect(() => { setPage(1) }, [term])

    return (
        <Container>
            <Heading title="Opções">
                <ButtonGroup size="xs">
                    <Button children="Adicionar opção" isLoading={options.isFetching} colorScheme="green" onClick={() => addOption.onOpen()} />
                    <IconButton icon="refresh" isLoading={options.isFetching} onClick={options.refetch} />
                    <Dev data={options} />
                </ButtonGroup>
            </Heading>

            <Searchable
                value={term}
                setValue={setTerm}
                placeholder="Pesquisar Opção pela chave..."
            />

            <Table
                columns={columns}
                meta={options?.data?.meta}
                loading={options.isLoading}
                setPage={setPage}
            >
                {options.data?.data?.map((item) =>
                    !!item && (
                        <Item key={item.key} data={item} onClick={() => handleOpenUpdateOptionModal(item.key)} />
                    )
                )}
            </Table>
            <OptionModals.UpdateOption optionKey={optionKey} {...updateOption} />
            <OptionModals.AddOption {...addOption} />
        </Container>
    )
}

const Item = ({ data: item, ...props }) => (
    <Row {...props}>
        {/* CHAVE */}
        <Td children={item.key} />

        {/* VALOR */}
        <Td children={item.value} maxWidth={300} style={{ textWrap:'wrap' }} />

        {/* DATA DE CRIAÇÃO */}
        <Td children={item.created_at ? Moment(item.created_at).calendar() : "--"} />

        {/* DATA DE ATUALIZAÇÃO */}
        <Td children={item.updated_at ? Moment(item.updated_at).calendar() : "--"} />
    </Row>
)
